// extracted by mini-css-extract-plugin
export default {"speed":"speedometer_speed__1tasu","indicator":"speedometer_indicator__V6ZFU"};